// AutoGenerated
export class SarkiYorumModel {
    sarkiModelId!: string;
    baslik!: string;
    icerik!: string;
    koroModelId!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}